import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetCustomerTag = (data) => rootApi.get('/user_rfid/search', { params: data });

export const apiAddCustomerTag = (data) => rootApi.post(`/user_rfid/create`, data);

export const apiDeleteCustomerTag = (idTag) => rootApi.delete(`/user_rfid/delete?idTag=${idTag}`);

export const apiConfirmCustomer = (id) => rootApi.post(`/admin/users/confirm-cccd/${id}`);

export const apiRejectCustomer = (id) => rootApi.post(`/admin/users/reject-cccd/${id}`);

export const apiUpdateCustomerCCCD = (id, data) => rootApi.put(`/admin/users/${id}/cccd`, data);

export const apiUpdateCustomerProfile = (id, data) =>
  rootApi.put(`/admin/users/${id}/profile`, data);

export const apiSetCustomerFundedPartner = (id, data) =>
  rootApi.put(`/admin/users/${id}/funded-partner`, data);

export const apiAdminChangeCustomerPassword = (id, data) =>
  rootApi.post(`/admin/users/reset-password/${id}`, data);

// Partner customer management (SUB_ADMIN)
export const apiGetPartnerCustomers = ({ depotCode, keyword, fromDate, toDate, page, size }) =>
  rootApi.get('/partners/customers', {
    params: {
      ...(depotCode ? { depot_code: depotCode } : {}),
      ...(keyword ? { keyword } : {}),
      ...(fromDate ? { from_date: fromDate } : {}),
      ...(toDate ? { to_date: toDate } : {}),
      page,
      size
    }
  });

export const apiGetPartnerCustomerRfids = (userId) =>
  rootApi.get(`/partners/customers/${userId}/rfids`);

export const apiAssignRfidToCustomer = (userId, data) =>
  rootApi.post(`/partners/customers/${userId}/rfids`, data);

export const apiRemoveRfidFromCustomer = (userId, idTag) =>
  rootApi.delete(`/partners/customers/${userId}/rfids`, { params: { id_tag: idTag } });

export const apiGetPartnerRfids = ({ keyword, groupId, type, page, size }) =>
  rootApi.get('/partners/rfids', {
    params: {
      ...(keyword ? { keyword } : {}),
      ...(groupId ? { group_id: groupId } : {}),
      ...(type ? { type } : {}),
      page,
      size
    }
  });

// Partner customer group (SUB_ADMIN: chỉ xem, nhóm do ADMIN quản lý)
export const apiGetPartnerCustomerGroups = () => rootApi.get('/partners/customer-groups');

export const apiGetPartnerCustomerGroup = (id) => rootApi.get(`/partners/customer-groups/${id}`);

export const apiGetGroupMembers = (groupId) =>
  rootApi.get(`/partners/customer-groups/${groupId}/members`);

// Partner customer group management (ADMIN)
const adminGroupPath = (partnerId) => `/admin/partners/${partnerId}/customer-groups`;

export const apiAdminGetPartnerGroups = (partnerId) => rootApi.get(adminGroupPath(partnerId));

export const apiAdminCreatePartnerGroup = (partnerId, data) =>
  rootApi.post(adminGroupPath(partnerId), data);

export const apiAdminUpdatePartnerGroup = (partnerId, id, data) =>
  rootApi.put(`${adminGroupPath(partnerId)}/${id}`, data);

export const apiAdminDeletePartnerGroup = (partnerId, id) =>
  rootApi.delete(`${adminGroupPath(partnerId)}/${id}`);

export const apiAdminGetGroupMembers = (partnerId, groupId) =>
  rootApi.get(`${adminGroupPath(partnerId)}/${groupId}/members`);

export const apiAdminAddGroupMember = (partnerId, groupId, userId) =>
  rootApi.post(`${adminGroupPath(partnerId)}/${groupId}/members`, { user_id: userId });

export const apiAdminRemoveGroupMember = (partnerId, groupId, userId) =>
  rootApi.delete(`${adminGroupPath(partnerId)}/${groupId}/members/${userId}`);

export const apiAdminSearchCustomers = (keyword) =>
  rootApi.get('/admin/users', {
    params: { search_username: keyword || undefined, sort_by: 'ID', page: 0, size: 20 }
  });

export const apiAdminCreateCustomer = (data) => rootApi.post('/admin/users/create-customer', data);
